export default {
    certificate: {
        certificateAdd: 'Добавить сертификат',
        certificateType: 'Тип сертификата',
        name: 'Название',
        number: 'Номер',
        amountInStock: 'Остаток',
        activationDate: 'Дата активации',
        deactivationDate:'Дата сгорания',
        cashDesk: 'Касса',
        status: 'Статус',
        faceValue: 'Номинал',
        typeWriteOff: 'Тип списания',
        balance: 'Номинал',
        AddPosition: 'Добавить позицию',
        coverage: 'Максимальный % от оплаты сертификата',
        period: 'Срок действия от даты продажи',
    },
};
